import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { RegistreService } from '../registre.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize, map } from 'rxjs';
import { helper } from 'src/environments/helper';

@Component({
	selector: 'app-edit-registre',
	templateUrl: './edit-registre.component.html',
	styleUrls: ['./edit-registre.component.scss']
})
export class EditRegistreComponent implements OnInit {

	// general error
	errorTitle: string = environment.config.customNotifications.headers.error
	errorIcon: string = environment.config.customNotifications.icons.error
	errorType: string = environment.config.customNotifications.icons.error
	helper = helper;

	token!: string;
	isLoading = false;
	// serieType$: any = [];

	defaultParameter: { name: string; id: string } = {
        name: '--Alegeți--',
        id: '-1',
    };
    serieType: { id: string, name: string }[] = [
        this.defaultParameter,
        { 
            name: "Resetabilă anual",
            id:'1',  
        },
        { 
            name: "Numărătoare continuă",
            id:'2',  
        },
    ];

	form: FormGroup = new FormGroup({
        name: new FormControl(this.data.name, [Validators.required]),
        slug: new FormControl(this.data.slug, [Validators.required]),
        // first_number: new FormControl(this.data.first_number, [Validators.required]),
        serie_type: new FormControl(this.data.serie_type.toString(), [Validators.required, Validators.min(1)]),
        observatii: new FormControl(this.data.observatii),
	});

	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data: any,
		private dialogRef: MatDialogRef<EditRegistreComponent>,
		private registreService: RegistreService,
		private notificationService: NotificationService,
		private authService: AuthService
	) {
		this.processToken();
	}

	ngOnInit(): void {
		// this.loadDocumentSerieType();
	}

	closeDialog() {
		this.dialogRef?.close({
			success: false,
		});
	}

	processToken() {
		const tokenObj = this.authService.returnTokenUser();
		tokenObj.then((token) => {
			this.token = token;
			this.registreService.setToken(token);
		});
	}

	submitForm() {
		this.isLoading = true;

		const updatedRegistreData = {
			id: this.data.id,
			name: this.form.get('name')?.value,
			slug: this.form.get('slug')?.value,
			// first_number: this.form.get('first_number')?.value,
			serie_type: this.form.get('serie_type')?.value,
			observatii: this.form.get('observatii')?.value,
		};

		this.registreService
			.updateRegistre(updatedRegistreData)
			.pipe(finalize(() => (this.isLoading = false)))
			.subscribe({
				next: () => {
					this.dialogRef.close({ success: true });
				},
				error: (err) => {
					let errorMessage =
						environment.config.customNotifications.generalMessages.error;
					this.notificationService.warningSwal(
						this.errorTitle,
						errorMessage,
						this.errorIcon
					);
				},
			});
	}

	// loadDocumentSerieType() {
	// 	this.isLoading = true;
	// 	this.serieType$ = this.registreService
	// 		.getRecordsList()
	// 		.pipe(
	// 			map((results: any) => [this.defaultParameter, ...results]),
	// 			finalize(() => (this.isLoading = false)));
	// }
}
